import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IRootState } from '../reducers';

import { IMessage } from '../actions/message';
import * as Actions from '../actions/user';
import MessageDialog from '../components/MessageDialog';
import ReactTable, {
	RowInfo,
	RowRenderProps,
} from '../components/MyReactTable';
import i18n from '../resources/i18n';

const styles = (theme: Theme) =>
	createStyles({
		checkbox: {
			height: 36,
			width: 36,
		},
		pointer: {
			cursor: 'pointer',
		},
	});

interface IState {
	messages: IMessage[];
	openMessageDialog: boolean;
	selectColumnsMenuAnchorEl?: HTMLElement;
	selectedRows: number[];
}

/**
 * ユーザ選択一覧
 */
class SelectUserTable extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			messages: [],
			openMessageDialog: false,
			selectedRows: [],
		};

		this.closeMessageDialog = this.closeMessageDialog.bind(this);
		this.getAllColumns = this.getAllColumns.bind(this);
		this.getSelectedColumns = this.getSelectedColumns.bind(this);
		this.getSelectColumnsMenu = this.getSelectColumnsMenu.bind(this);
		this.handleSelectColumns = this.handleSelectColumns.bind(this);
		this.handleCloseSelectColumns = this.handleCloseSelectColumns.bind(
			this
		);
		this.handleChangeCheckBox = this.handleChangeCheckBox.bind(this);
		this.select = this.select.bind(this);
	}

	public render() {
		const columns = this.getSelectedColumns();
		const selected = this.state.selectedRows.length;
		const indicator =
			selected > 0 ? `${selected}${i18n.t('SelectUserTable_0001')}` : '';
		return (
			<div>
				<ReactTable
					data={this.props.data}
					columns={columns}
					defaultPageSize={5}
					className="-striped -highlight"
					sortable={true}
					getTrProps={this.createTrProps}
					indicator={indicator}
					columnsMenu={true}
					menuHandler={this.handleSelectColumns}
				/>
				{this.getSelectColumnsMenu()}
				<Button
					variant="contained"
					color="primary"
					onClick={this.select}
				>
					{i18n.t('SelectUserTable_0002')}
				</Button>
				<MessageDialog
					open={this.state.openMessageDialog}
					title={i18n.t('SelectUserTable_0003')}
					contents={this.state.messages}
					onClickOk={this.closeMessageDialog}
					onClose={this.closeMessageDialog}
					showCancelButton={false}
				/>
			</div>
		);
	}

	/**
	 * Trのプロパティ生成処理
	 */
	protected createTrProps = (state: any, rowInfo: RowInfo) => {
		return {
			style: {
				height: 51,
			},
		};
	};

	/**
	 * メッセージダイアログクローズ処理
	 */
	protected closeMessageDialog() {
		this.setState({
			messages: [],
			openMessageDialog: false,
		});
	}

	/**
	 * 選択行情報設定
	 */
	protected onChangeCheckbox(index?: number) {
		return (e: React.ChangeEvent<HTMLInputElement>) => {
			const { checked } = e.target;
			if (index === undefined) {
				return;
			}

			const newSelectedRows = Object.assign([], this.state.selectedRows);
			const selectedIndex = newSelectedRows.indexOf(index);
			if (checked) {
				if (selectedIndex === -1) {
					newSelectedRows.push(index);
				}
			} else {
				if (selectedIndex !== -1) {
					newSelectedRows.splice(selectedIndex, 1);
				}
			}
			this.setState({
				selectedRows: newSelectedRows,
			});
		};
	}

	/**
	 * 全カラム取得処理
	 */
	protected getAllColumns() {
		return [
			{
				Cell: (row: RowRenderProps) => {
					const index = row.index !== undefined ? row.index : -1;
					const checked =
						this.state.selectedRows.indexOf(index) === -1
							? false
							: true;
					return (
						<div>
							<Checkbox
								className={this.props.classes.checkbox}
								data-index={row.index}
								onChange={this.onChangeCheckbox(row.index)}
								checked={checked}
							/>
						</div>
					);
				},
				accessor: 'sousa',
				required: true,
				sortable: false,
				width: 46,
			},
			{
				Header: i18n.t('SelectUserTable_0004'),
				accessor: 'loginId',
				width: 100,
			},
			{
				Header: i18n.t('SelectUserTable_0005'),
				accessor: 'name',
				width: 150,
			},
			{
				Header: i18n.t('SelectUserTable_0006'),
				accessor: 'orgPath',
				width: 150,
			},
			{
				Header: i18n.t('SelectUserTable_0007'),
				accessor: 'homePhone',
				width: 120,
			},
			{
				Header: i18n.t('SelectUserTable_0008'),
				accessor: 'titleName',
				width: 150,
			},
		];
	}

	/**
	 * 選択列絞り込み処理
	 */
	protected getSelectedColumns() {
		const columns: any[] = Object.assign([], this.getAllColumns());

		columns.map((column: any) => {
			if (column.required) {
				column.show = true;
			} else {
				column.show = false;
			}
		});

		this.props.selectedColumns.map((index: number) => {
			columns[index].show = true;
		});

		return columns;
	}

	/**
	 * 列選択メニュー取得処理
	 */
	protected getSelectColumnsMenu() {
		const { classes } = this.props;
		const allColumns = this.getAllColumns();
		const checkboxList: any[] = [];
		allColumns.map((column: any, index: number) => {
			if (!column.required) {
				checkboxList.push({
					checked: this.props.selectedColumns.indexOf(index) !== -1,
					index,
					text: column.Header,
				});
			}
		}, this);

		return (
			<Menu
				id="logout-menu"
				anchorEl={this.state.selectColumnsMenuAnchorEl}
				open={this.state.selectColumnsMenuAnchorEl ? true : false}
				onClose={this.handleCloseSelectColumns}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
			>
				{checkboxList.map((checkboxItem, i) => {
					return (
						<MenuItem key={i}>
							<Checkbox
								id={checkboxItem.text}
								onChange={this.handleChangeCheckBox(
									checkboxItem
								)}
								checked={checkboxItem.checked}
							/>
							<InputLabel
								className={classes.pointer}
								htmlFor={checkboxItem.text}
							>
								{checkboxItem.text}
							</InputLabel>
						</MenuItem>
					);
				})}
			</Menu>
		);
	}

	/**
	 * 列選択メニュー表示処理
	 */
	protected handleSelectColumns = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({
			selectColumnsMenuAnchorEl: event.currentTarget,
		});
	};

	/**
	 * 列選択メニュー非表示処理
	 */
	protected handleCloseSelectColumns = () => {
		this.setState({
			selectColumnsMenuAnchorEl: undefined,
		});
	};

	/**
	 * 表示列変更処理
	 */
	protected handleChangeCheckBox = (checkboxItem: any) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const newSelectedColumns = Object.assign(
			[],
			this.props.selectedColumns
		);
		const idx = newSelectedColumns.indexOf(checkboxItem.index);

		if (event.target.checked) {
			if (idx === -1) {
				newSelectedColumns.push(checkboxItem.index);
			}
		} else {
			if (idx !== -1) {
				newSelectedColumns.splice(idx, 1);
			}
		}

		this.props.setSelectedColumns(newSelectedColumns);
	};

	/**
	 * 選択処理
	 */
	protected select() {
		// 入力チェック
		if (this.state.selectedRows.length === 0) {
			// 0件の場合
			const message: IMessage = {
				content: 'LMCM_E_00103',
			};
			this.setState({
				messages: [message],
				openMessageDialog: true,
			});
			return;
		} else if (this.state.selectedRows.length > 1) {
			// 1件より多い場合
			const message: IMessage = {
				content: 'LMCM_E_00104',
				replacements: ['1'],
			};
			this.setState({
				messages: [message],
				openMessageDialog: true,
			});
			return;
		}

		const index = this.state.selectedRows[0];
		const selectUser = this.props.data[index];
		this.props.onSelect(selectUser);
	}
}

const mapStateToProps = (state: IRootState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	setSelectedColumns: (selectedColumns: number[]) =>
		dispatch(Actions.setSelectUserSelectedColumns({ selectedColumns })),
});

interface ISelectUserTableProps {
	data: Actions.ISelectUser[];
	onSelect: (selectUser: Actions.ISelectUser) => void;
	selectedColumns: number[];
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ISelectUserTableProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(SelectUserTable);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/SelectUserTable.tsx